var React = require('react');

function CommentAltSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M75.89 26.89A64 64 0 0 1 128 0h384a64.06 64.06 0 0 1 64 64v288a63.75 63.75 0 0 1-19.81 46.23zM64 352a64.06 64.06 0 0 0 64 64h96v84a12 12 0 0 0 19.1 9.7L368 416h2L64 179.5z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M636.67 480.52l-19.6 25.31a16.06 16.06 0 0 1-22.5 2.8L6.17 53.79a15.94 15.94 0 0 1-2.8-22.41L23 6.17a16.06 16.06 0 0 1 22.5-2.8l588.3 454.84a15.86 15.86 0 0 1 2.87 22.31z","className":"fa-primary","key":2})]);
}

CommentAltSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = CommentAltSlash;

CommentAltSlash.default = CommentAltSlash;
